import "@/App.css";
import "./mobile.css";
import { BrowserRouter, Routes, Route, Navigate, Link } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import InstallPrompt from "./components/InstallPrompt";
import MobileNav from "./components/MobileNav";
import SplashScreen from "./components/SplashScreen";
import Explore from "./pages/Explore";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Institutes from "./pages/Institutes";
import Rankings from "./pages/Rankings";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";
import PackagesPage from "./pages/PackagesPage";
import InstitutionDetail from "./pages/InstitutionDetail";
import Login from "./pages/Login";
import Privacy from "./pages/Privacy";
import { DemoAccess } from "./components/AccountActions";
import Referrals, { ReferralLanding } from "./pages/Referrals";
import StudentDashboard from "./pages/StudentDashboard";
import InstituteDashboard from "./pages/InstituteDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import Onboarding from "./pages/Onboarding";
import Teachers from "./pages/Teachers";
import TeacherDetail from "./pages/TeacherDetail";
import TeacherDashboard from "./pages/TeacherDashboard";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/institutes" element={<Institutes />} />
      <Route path="/rankings" element={<Rankings />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/packages" element={<PackagesPage />} />
      <Route path="/institution/:id" element={<InstitutionDetail />} />
      <Route path="/institutes/:id" element={<InstitutionDetail />} />
      <Route path="/explore/teachers" element={<Navigate to="/teachers" replace />} />
      <Route path="/explore/:kind" element={<Explore />} />
      <Route path="/teachers" element={<Teachers />} />
      <Route path="/home-tuition" element={<Teachers tuition />} />
      <Route path="/teachers/:id" element={<TeacherDetail />} />
      <Route path="/teacher" element={<Protected role="teacher"><TeacherDashboard /></Protected>} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Login register />} />
      <Route path="/ref/:code" element={<ReferralLanding />} />
      <Route path="/referrals" element={<Protected><Referrals /></Protected>} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/student" element={<Protected role="student"><StudentDashboard /></Protected>} />
      <Route path="/institute" element={<Protected role="institute"><InstituteDashboard /></Protected>} />
      <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function Protected({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-16 text-center text-muted-foreground">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.profile_complete === false) return <Navigate to="/onboarding" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

const NotFound = () => (
  <div className="max-w-xl mx-auto px-4 py-24 text-center">
    <p className="font-display text-6xl font-extrabold">404</p>
    <p className="mt-3 text-muted-foreground">This page doesn't exist.</p>
    <Link to="/" data-testid="notfound-home-link" className="nb-btn nb-btn-lime mt-6">Back to Home</Link>
  </div>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Navbar />
        <SplashScreen />
        <InstallPrompt />
        <AppRoutes />
        <Footer />
        <div className="md:hidden h-16" />
        <MobileNav />
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
